import React, { Component } from "react";
import { Spin } from "antd";
import { connect } from "dva";
import Container from "@/components/Container";
import Content from "./Content";
import styles from "./index.less";

@connect(({ self }) => ({
  ...self
}))
class MySelfEvaluation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentProjectId: "",
      showContent: false
    };
  }

  componentDidMount() {
    const {
      location: { query }
    } = this.props;
    const { currentProjectId } = query;
    this.setState({
      currentProjectId,
      showContent: true
    });
    this.getDetail(currentProjectId);
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "self/reset"
    });
  }

  getDetail = id => {
    // 通过id 获取详情
    const { dispatch } = this.props;
    dispatch({
      type: "self/fetchDetail",
      payload: {
        projectId: id
      }
    });
  };

  render() {
    const { currentProjectId, showContent } = this.state;
    const { dispatch, spinProps, endTime, progress, appendix, allowEdit } = this.props;
    const containerProps = {
      breStates: true,
      version: 2,
      isPathParams: true
    };
    const contentProps = {
      dispatch,
      currentProjectId,
      endTime,
      progress,
      appendix,
      allowEdit
    };
    return (
      <Container {...containerProps}>
        <div className={styles.selfEvaluation}>
          <Spin {...spinProps}>
            {showContent && <Content {...contentProps} />}
          </Spin>
        </div>
      </Container>
    );
  }
}

export default MySelfEvaluation;
